<template>
  <div class="match-layout">
    <score-board :sport="sport" :league="league" :event="event">
      <div class="score-board-table">
        <div class="teams">{{ event.home + (event.away ? ' - ' + event.away : '') }}</div>
        <div class="time">{{ event.time | moment('add', '-3 hours') | moment('DD/MM HH:mm') }}</div>
      </div>
    </score-board>
    <market-filter :suite="event.groups" @change="marketGroup = arguments[0]" />
    <span class="search">
      <input class="head-text" type="text" :placeholder="$t('search.placeholder')" v-model="query" />
    </span>
    <factor-list :periods="periods" :event="event" :group="marketGroup" :query="query" />
  </div>
</template>

<script>
import SportIcon from '@/components/icons/SportIcon'
import ScoreBoard from '@/components/sports/eventview/ScoreBoard'
import MarketFilter from '@/components/sports/eventview/MarketFilter'
import FactorList from '@/components/sports/eventview/FactorList'
import { mapState } from 'vuex'

export default {
  components: { SportIcon, ScoreBoard, MarketFilter, FactorList },
  computed: {
    ...mapState({
      sport: state => state.prematch.eventview.sport,
      league: state => state.prematch.eventview.league,
      event: state => state.prematch.eventview.event,
      periods: state => state.prematch.eventview.periods
    })
  },
  data () {
    return {
      marketGroup: 'a',
      query: ''
    }
  },
  mounted () {
    console.log(event)
  }
}
</script>

<style scoped>
.match-layout { /* margin: 0 10px; */ margin-right: 10px; }
.score-board-table { /* background: rgba(117,80,118,.1); */ border-radius: 3px; display: flex; flex-direction: column; height: 100px; left: 50%; margin: 18px 0 0 -250px; padding: 2px 14px; position: absolute; width: 500px; text-align: center; border: 1px solid hsla(0,0%,100%,.07) !important;}
.score-board .teams { font-size: 17px; line-height: 40px; margin-top: 14px; }
.score-board .time { color: #713592; font-size: 15px; }

.search { float: right; }

input {
    border: none;
    border-radius: 10px;
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    width: 145px;
    transition: background .3s;
    color: #231e4a;
    margin-bottom: 0px;
    margin-left: 5px;
    border: 1px solid #713592;
    margin-top: 5px;
}
input:focus::-webkit-input-placeholder { color: transparent; border: none; }
input:focus::-moz-placeholder { color: transparent; border: none; }
input:focus:-moz-placeholder { color: transparent; border: none; }
input:focus:-ms-input-placeholder { color: transparent; border: none; }
input::-webkit-input-placeholder { color: #231e4a; opacity: 1; }
input::-moz-placeholder { color: #231e4a; opacity: 1; }
input:-ms-input-placeholder { color: #231e4a; opacity: 1; }
input:-moz-placeholder { color: #231e4a; opacity: 1; }

</style>



// WEBPACK FOOTER //
// src/components/sports/eventview/Event.vue